export const paletteLight = {
  type: "light",
  shadow1: "0 2px 4px 0 rgba(0, 0, 0, 0.1)",
  shadow2: "0 5px 8px 0 rgba(0, 0, 0, 0.1)",
  shadow3: "0 9px 10px 0 rgba(0, 0, 0, 0.1)",
  shadow4: "0 20px 30px 0 rgba(0, 0, 0, 0.1)",
  shadow5: "0 30px 30px 0 rgba(0, 0, 0, 0.1)",
  transition1: "0.1s",
  transition2: "0.2s",
  transition3: "0.3s",
  background: {
    tableRow: "#f9fafd",
    tableRowHead: "#eef1f7",
    tableRowHeadText: "#9ea3b3",
    main: "#f4f6fc",
    paper: "#ffffff",
    sidebar: "#eceff8",
    sidebarOver: "#f8f9fc",
  },
  primary: {
    main: "#13d46c",
    shadow: "#02b856",
    tint60: "#72e5a7",
    tint35: "#adf0cc",
    tint12: "#e3faee",
    tint90: "#39c05f", //without name :(
    tint100: "#0bc561",
  },
  secondary: {
    main: "#09133e",
    shadow: "#050c2c",
    tint15: "#dadce2",
    tint1515: "rgba(218, 220, 226, 0.15)",
    tint40: "#9da1b2",
    tint60: "#6b718b",
    tint90: "#222b51", //dark-blue-grey
    tint100: "#ced0d9",
  },
  error: {
    main: "#d63749",
  },
  alert: {
    main: "#f7c138",
  },
  info: {
    main: "#34bcee",
  },
  black: {
    main: "#000000",
  },
  white: {
    main: "#ffffff",
    qrCode: "#ffffff",
  },
  success: {
    main: "#33ac2e",
    shadow: "#269722",
    tint60: "#85cd82",
    tint35: "#b8e2b6",
    tint12: "#e6f5e6",
  },
  red: {
    main: "#d63649",
    shadow: "#c32a3c",
    tint60: "#e68692",
    tint35: "#f1b9c0",
    tint12: "#fae6e9",
  },
  red2: {
    main: "#ee5d4b",
    shadow: "#da4b3a",
    tint60: "#f59e93",
    tint35: "#f9c7c0",
    tint12: "#fdebe9",
  },
  purple: {
    main: "#8c54ff",
    shadow: "#6923fa",
    tint60: "#b896fe",
    tint35: "#d7c3ff",
    tint12: "#f1eaff",
  },
  yellow: {
    main: "#f7c137",
    shadow: "#e5b029",
    tint60: "#fada87",
    tint35: "#fceab9",
    tint12: "#fef7e7",
  },
  blue: {
    main: "#2e5bff",
    shadow: "#1e49e9",
    tint60: "#829dff",
    tint35: "#b6c6ff",
    tint12: "#e6ebff",
  },
  teal: {
    main: "#34bcee",
    shadow: "#22aadc",
    tint60: "#85d7f5",
    tint35: "#b8e8f9",
    tint12: "#e6f7fd",
  },
  gray1: {
    main: "#eef3f5",
  },
  gray2: {
    main: "#f4f6fc",
  },
  gray3: {
    main: "#788294",
  },
};
export const paletteDark = {
  type: "dark",
  shadow1: "0 2px 4px 0 rgba(0, 0, 0, 0.1)",
  shadow2: "0 5px 8px 0 rgba(0, 0, 0, 0.1)",
  shadow3: "0 9px 10px 0 rgba(0, 0, 0, 0.1)",
  shadow4: "0 20px 30px 0 rgba(0, 0, 0, 0.1)",
  shadow5: "0 30px 30px 0 rgba(0, 0, 0, 0.1)",
  background: {
    main: "#050c2c",
    paper: "#09133e",
    sidebar: "#09133e",
    tableRow: "#222b51",
    tableRowHead: "#6b718b",
    tableRowHeadText: "#9da1b2",
  },
  primary: {
    main: "#14d46c",
    shadow: "#02b856",
    tint60: "#72e5a7",
    tint35: "#adf0cc",
    tint12: "#e3faee",
    tint100: "#0bc561",
  },
  secondary: {
    main: "#ffffff",
    shadow: "#050c2c",
    tint15: "#dadce2",
    tint1515: "rgba(34, 43, 81, 0.2)",
    tint40: "#9da1b2",
    tint60: "#6b718b",
    tint90: "##6b718b",
    tint100: "#ced0d9",
  },
  error: {
    main: "#d63749",
  },
  alert: {
    main: "#f7c138",
  },
  info: {
    main: "#34bcee",
  },
  black: {
    main: "#ffffff",
  },
  white: {
    main: "#222b51",
    qrCode: "#ffffff",
  },
  success: {
    main: "#33ac2e",
    shadow: "#269722",
    tint60: "#85cd82",
    tint35: "#b8e2b6",
    tint12: "#e6f5e6",
  },
  red: {
    main: "#d63649",
    shadow: "#c32a3c",
    tint60: "#e68692",
    tint35: "#f1b9c0",
    tint12: "#fae6e9",
  },
  red2: {
    main: "#ee5d4b",
    shadow: "#da4b3a",
    tint60: "#f59e93",
    tint35: "#f9c7c0",
    tint12: "#fdebe9",
  },
  purple: {
    main: "#8c54ff",
    shadow: "#6923fa",
    tint60: "#b896fe",
    tint35: "#d7c3ff",
    tint12: "#f1eaff",
  },
  yellow: {
    main: "#f7c137",
    shadow: "#e5b029",
    tint60: "#fada87",
    tint35: "#fceab9",
    tint12: "#fef7e7",
  },
  blue: {
    main: "#2e5bff",
    shadow: "#1e49e9",
    tint60: "#829dff",
    tint35: "#b6c6ff",
    tint12: "#e6ebff",
  },
  teal: {
    main: "#34bcee",
    shadow: "#22aadc",
    tint60: "#85d7f5",
    tint35: "#b8e8f9",
    tint12: "#e6f7fd",
  },
  gray1: {
    main: "#eef3f5",
  },
  gray2: {
    main: "#222b51",
  },
  gray3: {
    main: "#788294",
  },
};
